import { useState } from 'react'
import './FloorFilter.css'

const DEFAULT_FLOORS = [
  { id: 1, label: 'Tầng 1' },
  { id: 2, label: 'Tầng 2' },
  { id: 3, label: 'Tầng 3' },
  { id: 4, label: 'Tầng 4' },
  { id: 5, label: 'Tầng 5' },
  { id: 6, label: 'Tầng 6' },
  { id: 7, label: 'Tầng 7' },

]

/**
 * FloorFilter — bộ lọc mặt bằng theo tầng
 * @param {Array}    floors        - danh sách tầng [{ id, label }]
 * @param {number}   activeFloor   - id tầng đang chọn (controlled)
 * @param {Function} onFloorChange - callback khi chọn tầng
 */
function FloorFilter({ floors = DEFAULT_FLOORS, activeFloor, onFloorChange }) {
  const [internalActive, setInternalActive] = useState(floors[0]?.id ?? null)

  const selected = activeFloor ?? internalActive

  const handleSelect = (id) => {
    setInternalActive(id)
    onFloorChange?.(id)
  }

  return (
    <div className="floor-filter" role="navigation" aria-label="Lọc theo tầng">
      {/* Title */}
      <h3 className="floor-filter__title">Mặt Bằng Tầng</h3>

      {/* List */}
      <ul className="floor-filter__list" role="list">
        {floors.map(({ id, label }) => {
          const isActive = selected === id
          return (
            <li key={id} className="floor-filter__item">
              <button
                id={`floor-btn-${id}`}
                type="button"
                className={`floor-filter__btn${isActive ? ' floor-filter__btn--active' : ''}`}
                aria-pressed={isActive}
                onClick={() => handleSelect(id)}
              >
                {label}
              </button>
            </li>
          )
        })}
      </ul>
    </div>
  )
}

export default FloorFilter
